export function uniqueSorted(values) {
  return [...new Set(values.map((value) => (value || "").trim()).filter(Boolean))].sort((a, b) =>
    a.localeCompare(b, "it")
  );
}

export function isEmailVerified(user) {
  const value = user?.is_verified ?? user?.isVerified;
  return value === true || value === 1 || value === "1" || value === "true";
}

export function selectRegistrationFilters(registrationFields) {
  return (registrationFields || []).filter(
    (field) => field && field.type === "select" && field.id && Array.isArray(field.options) && field.options.length > 0
  );
}

export function userFieldValue(user, fieldId) {
  if (!user || !fieldId) return "";
  const custom = user.custom_fields && typeof user.custom_fields === "object" ? user.custom_fields : {};
  if (custom[fieldId] != null && custom[fieldId] !== "") return String(custom[fieldId]);
  if (user[fieldId] != null && user[fieldId] !== "") return String(user[fieldId]);
  return "";
}

export function filterIscrizioni(users, filters = {}) {
  const verified = filters.verified || "";
  const applicationId = filters.applicationId;
  const fieldFilters = {
    ...(filters.fields && typeof filters.fields === "object" ? filters.fields : {}),
  };
  // Retrocompatibilità con i filtri croas/provincia usati nei test/vecchie UI
  if (filters.croas) fieldFilters.croas = filters.croas;
  if (filters.provincia) fieldFilters.provincia = filters.provincia;

  return (users || []).filter((user) => {
    if (applicationId !== "" && applicationId != null && String(user.application_id) !== String(applicationId)) {
      return false;
    }
    for (const [fieldId, rawValue] of Object.entries(fieldFilters)) {
      const expected = String(rawValue || "").trim();
      if (!expected) continue;
      if (userFieldValue(user, fieldId).trim() !== expected) return false;
    }
    if (verified === "verified" && !isEmailVerified(user)) return false;
    if (verified === "unverified" && isEmailVerified(user)) return false;
    return true;
  });
}

export function iscrittiCountLabel(count) {
  return `${count} ${count === 1 ? "iscritto" : "iscritti"}`;
}

export function iscrizioneExtraSummary(user, selectFields) {
  const fields = selectFields?.length
    ? selectFields
    : [{ id: "provincia" }, { id: "croas" }];
  return fields
    .map((field) => userFieldValue(user, field.id))
    .map((value) => value.trim())
    .filter(Boolean)
    .join(" · ");
}
